import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { AdminHeader, Modal, ConfirmDelete, EditBtn, AddBtn, Field } from "../../components/admin/AdminUI";
import { FileText } from "lucide-react";

const empty = { title: "", description: "", file_url: "", file_type: "pdf", category: "General" };

export default function DownloadsAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/downloads").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/admin/downloads/${editing}`, form);
      else await api.post("/admin/downloads", form);
      toast.success("Saved");
      setOpen(false); setForm(empty); setEditing(null); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };
  const edit = (d) => { setEditing(d.id); setForm({ ...empty, ...d }); setOpen(true); };
  const del = async (id) => { await api.delete(`/admin/downloads/${id}`); load(); toast.success("Deleted"); };

  return (
    <div>
      <AdminHeader title="Downloads" subtitle="Manage downloadable documents and forms" actions={<AddBtn onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} />} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((d) => (
          <div key={d.id} className="card-elev p-5 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-brand-primary-light text-brand-primary flex items-center justify-center shrink-0"><FileText size={20} /></div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-brand-text truncate">{d.title}</div>
              <div className="text-xs text-brand-muted">{d.category} · {d.file_type}</div>
            </div>
            <div className="flex items-center gap-1"><EditBtn onClick={() => edit(d)} /><ConfirmDelete onConfirm={() => del(d.id)} /></div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-brand-muted py-10">No downloads yet.</div>}
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit Download" : "New Download"}>
        <form onSubmit={save} className="grid gap-4">
          <Field label="Title *"><input required value={form.title} onChange={upd("title")} className="form-input" /></Field>
          <Field label="File URL *"><input required value={form.file_url} onChange={upd("file_url")} className="form-input" placeholder="https://…" /></Field>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Category"><input value={form.category} onChange={upd("category")} className="form-input" /></Field>
            <Field label="File Type"><select value={form.file_type} onChange={upd("file_type")} className="form-input">{["pdf", "doc", "xls", "ppt", "zip", "img"].map((t) => <option key={t}>{t}</option>)}</select></Field>
          </div>
          <Field label="Description"><textarea rows={3} value={form.description} onChange={upd("description")} className="form-input" /></Field>
          <div className="flex justify-end gap-2"><button type="button" onClick={() => setOpen(false)} className="btn-ghost">Cancel</button><button className="btn-primary">Save</button></div>
        </form>
      </Modal>
    </div>
  );
}
